module.exports = __webpack_public_path__ + "static/media/hangman_2.32fcbb0d.svg";